import React from "react";
import { useState } from "react";

const MAP_EMBEDED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3949.718040682165!2d-34.90547892499132!3d-8.130161791899559!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ab1f0655555555%3A0x831f0c5fa66b8385!2sPonteio%20Churrascaria!5e0!3m2!1spt-BR!2sbr!4v1727548974970!5m2!1spt-BR!2sbr';
const MAP_TITLE = 'Ponteio Churrascaria';

export const Maps = () => {
    const [endereco, setEndereco] = useState('');
    const MAP_REDIRECT_URL = `https://www.google.com/maps/dir/${endereco}/Ponteio+Churrascaria+-+Av.+Visc.+de+Jequitinhonha,+138+-+Boa+Viagem,+Recife+-+PE,+51030-020/@-8.1301565,-34.9054843,17z/data=!4m17!1m7!3m6!1s0x7ab1f0655555555:0x831f0c5fa66b8385!2sPonteio+Churrascaria!8m2!3d-8.1301618!4d-34.902904!16s%2Fg%2F1pzt9829g!4m8!1m0!1m5!1m1!1s0x7ab1f0655555555:0x831f0c5fa66b8385!2m2!1d-34.902904!2d-8.1301618!3e9?entry=ttu&g_ep=EgoyMDI0MDkyNS4wIKXMDSoASAFQAw%3D%3D`;
    return (
        <section className=" py-8 w-66 bg-slate-300 flex md:flex-row	 items-start md:justify-center gap-8 md:gap-16 flex-col-reverse ">
        

          <div className="bg-white p-2 mx-auto my-4 md:m-0 rounded-md shadow-xl">
            <IFrame />
          </div>

          <div className=" mx-auto md:m-0">
            <div className="text-center md:text-left ">
              <h2 className="text-4xl mb-4 amatic-sc-bold">Local do Casamento</h2>
              <h4 className="text-xl poppins-regular">Ponteio Churrascaria</h4>
              <p className="poppins-light mb-8">Av. Visc. de Jequitinhonha, 138 - Boa Viagem, Recife - PE, 51030-020</p>
            </div>
            <div className=" text-center md:text-left h-28">
              <input
                type="text"
                className="rounded-md border-2 border-transparent md:w-1/2 w-80  px-5 py-2 md:mr-4 text-xl font-semibold text-gray-700 outline-4 outline-senary transition-all focus:border-primary focus:bg-white focus:outline-none"
                placeholder="Digite seu endereço de origem"
                value={endereco}
                onChange={(e) => setEndereco(e.target.value)}
                />
              <a
                href={MAP_REDIRECT_URL}
                target="_blank"
                className="amatic-sc-bold cursor-pointer block md:inline mt-4 mx-auto rounded-md md:w-1/2 w-80 bg-emerald-950 px-5 py-2 text-xl md:text-2xl  font-semibold text-white outline-4 outline-senary transition-all hover:bg-senary disabled:pointer-events-none disabled:opacity-50"
                rel="noreferrer"
                >
                <button>Ver rota no Google Maps</button>
              </a>
            </div>
          </div>

            
          </section>
    )
}

const IFrame = () => {
  return (
    <iframe
        src={MAP_EMBEDED_URL}
        style={{ border: 0, height: '350px', width: '350px' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={MAP_TITLE}
        aria-label={MAP_TITLE}
      />
  )
}